import ComponentCard from "../../../components/common/ComponentCard";
import PageMeta from "../../../components/common/PageMeta";
import Button from "../../../components/ui/button/Button";
import { useNavigate } from "react-router-dom";
import InspectionsHistoryTable from "./InspectionsHistoryTable";

const InspectionHistory = () => {
  const navigate = useNavigate();

  return(
    <>
      <PageMeta 
        title="Compliance Inspections - Inspections History | Hospitality Genie"
        description="Compliance Inspections - Headings"
      />
      <div className="space-y-6">
      <ComponentCard title="Compliance Inspections - Inspection History">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">Compliance Inspections History</div>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
                className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium text-[#ffffed] rounded-lg bg-[#142900] hover:bg-[#e1ffb4] hover:text-[#142900]"
              >
                Filter Options
              </button>
            <Button
              className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-lg bg-[#142900] hover:bg-[#3d5e42]" size="sm" 
              onClick={() => navigate('/add-new-inspection-history')}
            >
              Add New Inspection History
            </Button>
            </div>
        </div>
        
        <div>
          {/* Table Component */}
          <InspectionsHistoryTable />
        </div>
      </ComponentCard>
      </div>
    </>
  );

}

export default InspectionHistory;